'use client';
/*
 * Documentation:
 * BasicCard04 — https://app.subframe.com/6fc7f5fbb098/library?component=BasicCard04_e2d0d13b-5d91-4419-af35-408b48c18a57
 */

import React from 'react';
import * as SubframeUtils from '../utils';

interface BasicCard04RootProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  badge?: React.ReactNode;
  avatar?: React.ReactNode;
  description?: React.ReactNode;
  metadata?: React.ReactNode;
  className?: string;
}

const BasicCard04Root = React.forwardRef<HTMLDivElement, BasicCard04RootProps>(
  function BasicCard04Root(
    {
      title,
      subtitle,
      badge,
      avatar,
      description,
      metadata,
      className,
      ...otherProps
    }: BasicCard04RootProps,
    ref,
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          'group/e2d0d13b bg-default-background hover:bg-brand-50 flex w-full cursor-pointer flex-col items-start gap-4 rounded-[16px] border border-solid border-neutral-200 px-4 py-4',
          className,
        )}
        ref={ref}
        {...otherProps}
      >
        <div className="flex w-full items-center gap-4">
          <div className="flex shrink-0 grow basis-0 flex-col items-start gap-1">
            {title ? (
              <span className="text-heading-3 font-heading-3 text-default-font w-full">
                {title}
              </span>
            ) : null}
            <div className="flex items-center gap-2">
              {subtitle ? (
                <span className="text-caption font-caption text-default-font">{subtitle}</span>
              ) : null}
              {badge ? <div className="flex items-center gap-2">{badge}</div> : null}
            </div>
          </div>
          {avatar ? <div className="flex items-center gap-4">{avatar}</div> : null}
        </div>
        <div className="flex w-full flex-col items-start gap-4">
          {description ? (
            <span className="text-body font-body text-default-font">{description}</span>
          ) : null}
          {metadata ? (
            <span className="text-caption font-caption text-subtext-color">{metadata}</span>
          ) : null}
        </div>
      </div>
    );
  },
);

const BasicCard04 = BasicCard04Root;
